import memoize from "fast-memoize";
import fetch from "./fetch-leads-api";

async function forms({ accountId }) {
  const response = await fetch(`/v1/forms/sales/trade/${accountId}`);
  const { fields } = await response.json();
  return fields;
}

export default memoize(forms, { serializer: ({ accountId }) => accountId });
